<template>
  <div class="form-group">
    <select class="form-control input-sm custom-select" @change="changeCompany($event)">
      <option :value="''" disabled selected>
        {{ $t('selectCompany') }}
      </option>
      <option :value="0">
        {{ $t("all") }}
      </option>
      <option v-for="item in data" :key="item.id" :value="item.id">
        {{ item.name }}
      </option>
    </select>
  </div>
</template>
<style scoped>
.custom-select {
 width: 16rem !important;
}
</style>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import agent from "@/services/agent";
import { CompanyInfo } from "../features/Company/Company.model";

// State
const data = ref<CompanyInfo[]>([]);

// Emits event
const emit = defineEmits(["onCompanyChange"]);

// Load company data when the component is mounted
async function loadCompany() {
  const response = (await agent.get<any>("v1/company")) || {};
  if (response.result) {
    data.value = response.result?.result;
  }
}

onMounted(() => {
  loadCompany();
});

// Handle company change
function changeCompany(event: Event) {
  const selectedCompanyId = (event.target as HTMLSelectElement).value;
  emit("onCompanyChange", selectedCompanyId);
}
</script>
